import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type UserService from 'walden-trace-app/services/user';

type Resolved<P> = P extends Promise<infer T> ? T : P;
export type PrivacyPolicyModel = Resolved<ReturnType<PrivacyPolicyRoute['model']>>;

export default class PrivacyPolicyRoute extends Route {
  @service('user') declare userService: UserService;

  async model() {
    const user = await this.userService.getUser();

    return {
      user,
    };
  }
}
